<template>
    <l-modal size="m" :close-on-backdrop-click="false" @close="cancel()">
        <template #header>
            {{ $t("skills.translate.modalTitle") }}
        </template>
        <template #body>
            <div class="tw-mt-4">
                <div v-for="language in languages" :key="language" class="tw-relative">
                    <l-input-text
                        v-model="translations[language]"
                        :label="languageName[language]"
                        :type="inputType"
                        optional
                        hide-help-block
                    />
                    <span
                        v-if="language !== 'en'"
                        class="tw-absolute tw-cursor-pointer"
                        style="top: -24px; right: 2px;"
                        tabindex="0"
                        @click="removeLanguage(language)"
                        @keyup.enter="removeLanguage(language)"
                    >
                        <i class="fal fa-times"></i>
                    </span>
                    <l-space :size="2" />
                </div>
            </div>

            <hr />

            <l-select
                :label="``"
                :options="optionsLanguages"
                @change="e => addLanguage(e.target.value)"
            />

            <p class="tw-mt-4">{{ $t(`skills.translate.helpText`) }}</p>

            <hr />

            <div class="footer">
                <button class="btn btn-primary" type="button" @click="cancel()">
                    <span>{{ $t("modal.labelCancel") }}</span>
                </button>
                <button class="btn btn-primary btn-raised" type="button" @click="confirm()">
                    <span>{{ $t("modal.labelConfirm") }}</span>
                </button>
            </div>
        </template>
    </l-modal>
</template>

<script>
import languages from "@/config/languages";

import LInputText from "@/components/LInputText";
import LModal from "@/components/LModal";
import LSelect from "@/components/LSelect";
import LSpace from "@/components/LSpace";

function sortLanguages(a, b) {
    if (a === "en") {
        return -1;
    }
    if (b === "en") {
        return 1;
    }

    return a < b ? -1 : 1;
}

export default {
    components: {
        LInputText,
        LModal,
        LSelect,
        LSpace,
    },
    props: {
        existingTranslations: {
            type: Object,
            required: true,
        },
        inputType: {
            type: String,
            default: "text",
        },
    },
    data() {
        return {
            languages: [],
            translations: {},
        };
    },
    computed: {
        optionsLanguages() {
            const options = languages
                .filter(lang => !this.languages.includes(lang.code))
                .map(lang => ({
                    value: lang.code,
                    text: lang.name,
                }));

            options.unshift({
                value: "",
                text: this.$t(`skills.translate.selectLanguagePlaceholder`),
            });

            return options;
        },
    },
    watch: {
        existingTranslations: {
            immediate: true,
            handler(value) {
                this.languages = Object.keys(value).sort(sortLanguages);
                this.translations = { ...value };
            },
        },
    },
    created() {
        this.languageName = languages.reduce((acc, cur) => {
            acc[cur.code] = cur.name;
            return acc;
        }, {});
    },
    methods: {
        addLanguage(lang) {
            if (!lang) {
                return;
            }

            this.languages.push(lang);
            this.languages.sort(sortLanguages);

            this.$set(this.translations, lang, "");
        },
        removeLanguage(lang) {
            this.languages.splice(
                this.languages.findIndex(l => l === lang),
                1,
            );
            delete this.translations[lang];
        },

        cancel() {
            this.$emit("cancel");
        },
        confirm() {
            this.$emit("confirm", this.translations);
        },
    },
};
</script>
